import React, { memo } from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import uuid from 'uuid';
import { currencyFormat } from '../../helpers/format';

const useStyles = makeStyles(() => ({
  list: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'start',
  },
  names: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'left',
  },
  toplist_box: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    padding: '20px',
    margin: '5px',
    backgroundColor: '#102b4e',
    color: '#FFF',
  },
  text: {
    fontFamily: '"Inter", sans-serif',
    fontSize: '16px',
    fontWeight: '500',
    color: '#202020',
  },
  text_bold: {
    fontFamily: '"DM Serif Display", serif',
    fontSize: '16px',
  },
  textOffice: {
    fontFamily: '"Inter", sans-serif',
    fontSize: '14px',
    fontWeight: '400',
    color: '#202020',
  },
  textOffice_bold: {
    fontFamily: '"DM Serif Display", serif',
    fontSize: '16px',
  },
  heading: {
    marginTop: '36px',
    fontFamily: '"Inter", sans-serif',
    fontSize: '18px',
    fontWeight: '600',
    lineHeight: '28px',
    color: '#202020',
  },
  tableBody: {
    '& > tr > td, & > tr > th': {
      borderBottom: '1px solid #e0e0e0',
    },
    '& > tr:last-child > td, & > tr:last-child > th': {
      borderBottom: 'none',
    },
  },
  table: {
    borderCollapse: 'collapse',
  },
  tableCell: {
    padding: '20px 16px',
  },
  tableCellNumber: {
    width: '20px',
    padding: '20px 16px',
    fontFamily: '"DM Serif Display", serif',
    fontSize: '24px',
    fontWeight: 400,
    lineHeight: '1.2',
    color: '#202020',
  },
  tableCellImage: {
    width: 'auto',
    padding: '10px 0',
  },
  profileImage: {
    width: '53px', // 50px för att matcha 2:3 ratio
    height: '80px', // 75px för att matcha 2:3 ratio
    borderRadius: '6px',
    objectFit: 'cover',
    objectPosition: 'top',
    imageRendering: 'auto',
    backfaceVisibility: 'hidden',
    transform: 'translateZ(0)',
  },
}));

function ToplistListing({ list, unit, heading, user, customerId, spain }) {
  const classes = useStyles({});
  if (!list) return;

  if (heading === 'I min närhet' || heading === 'Close to my ranking') {
    let index = list.map((l) => l.userId).indexOf(user.userId);
    if (index < 0) index = list.map((l) => l.customerId).indexOf(customerId);

    if (index > 0) {
      list = list.slice(
        Math.max(index - 2, 0),
        Math.min(index + 3, list.length)
      );
    } else list = null;
  }

  const areEqual = (row) => {
    if (customerId) return row.customerId === customerId;

    return row.userId === user.userId;
  };

  if (!list) return null;

  console.log(list);
  return (
    <>
      <Box className={classes.heading}>{heading}</Box>
      <TableContainer>
        <Table className={classes.table} aria-label="Toplist listing">
          <TableBody className={classes.tableBody}>
            {list.map((row) => (
              <TableRow key={uuid.v4()}>
                <TableCell
                  component="th"
                  scope="row"
                  classes={{ root: classes.tableCellNumber }}
                >
                  {row.place}
                </TableCell>
                <TableCell
                  classes={{ root: classes.tableCellImage }}
                  align="center"
                >
                  {row.imageUrl && (
                    <img
                      src={row.imageUrl}
                      alt={`${row.userName || 'User'} profile`}
                      className={classes.profileImage}
                      tabIndex={0}
                      aria-label={`${row.userName || 'User'} profile image`}
                      onClick={() => {}}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          e.preventDefault();
                        }
                      }}
                    />
                  )}
                  {!row.imageUrl && row.userName && (
                    <div
                      className={classes.profileImage}
                      style={{
                        backgroundColor: '#e0e0e0',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#757575',
                        fontSize: '24px',
                        fontWeight: 'bold',
                        margin: '0 auto',
                      }}
                    >
                      {row.userName.charAt(0).toUpperCase()}
                    </div>
                  )}
                </TableCell>
                <TableCell
                  component="th"
                  scope="row"
                  classes={{ root: classes.tableCell }}
                >
                  <Box style={{ display: 'flex', flexDirection: 'column' }}>
                    <Box
                      className={
                        areEqual(row) ? classes.text_bold : classes.text
                      }
                    >
                      {row.userName}
                    </Box>
                    <Box
                      className={
                        areEqual(row)
                          ? classes.textOffice_bold
                          : classes.textOffice
                      }
                    >
                      {row.customerName}
                    </Box>
                  </Box>
                </TableCell>
                <TableCell
                  align="right"
                  className={areEqual(row) ? classes.text_bold : classes.text}
                  classes={{ root: classes.tableCell }}
                >
                  {unit === 'kr' || unit === 'EUR' ? (
                    <Box>
                      {currencyFormat(row.value, spain ? 'eur' : 'sek')} {unit}
                    </Box>
                  ) : (
                    <Box>
                      {row.value} {unit}
                    </Box>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}

export default memo(ToplistListing);
